module.exports = __webpack_public_path__ + "dsslogo.a46e10aeecd02d91511466744b0cbe0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/logos/dsslogo.png
// module id = 728
// module chunks = 86